<template>
  <div class="table-div">
    <avue-crud ref="crud" :data="data" :option="TabOption" :page.sync="page" @on-load="onLoad"
      @search-change="searchChange" @size-change="sizeChange" @current-change="currentChange" @cell-click="rowEdit"
      :table-loading="loading" @search-reset="searchReset" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @selection-change="selectionChange">
      <!-- <template slot="clzt" slot-scope="scope">
        <template v-if="scope.row.clzt == 1"> 未通过 </template>
        <template v-else> 已通过 </template>
      </template> -->

      <template slot="menuLeft">
        <el-button type="primary" size="small" @click="downloadViewFunc" v-if="rola">下载模板</el-button>

        <el-button type="primary" size="small" @click="uploadFile" v-if="rola">导入</el-button>

        <el-button type="primary" size="small" @click="downloadDataFun">导出</el-button>

        <el-button type="primary" size="small" @click="deleteRows()" :loading="delLoading">催办</el-button>
      </template>
    </avue-crud>

    <!-- 导入模板选择试图 -->
    <el-dialog title="导入模板" :visible.sync="uploadView.show" width="30%" top="15vh" :append-to-body="true"
      @close="closeUploadDialog">
      <el-row>
        <el-form :inline="true" ref="downloadView" :model="uploadView.form" label-suffix=":">
          <el-col :span="24" ref="uploadViewData">
            <input type="file" class="file" @change="uploading($event)" />
            <el-button type="success" class="file_btn"><i class="el-icon-upload"></i><span
                v-text="uploadViewData.label">上传文件</span></el-button>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer">
        <el-button @click="uploadView.show = false">取 消</el-button>
        <el-button type="primary" @click="toUploadFile">确定上传</el-button>
      </span>
    </el-dialog>

    <!-- 导出错误数据 -->
    <el-dialog title="下载错误模板" :visible.sync="downloadErrorView.show" width="30%" top="15vh" :append-to-body="true">
      <el-row>
        <el-form :inline="true" ref="downloadErrorView" :model="downloadErrorView.form" label-suffix=":">
          <el-col :span="24">
            <el-form-item label="文件名称" prop="fileName" :rules="[{ required: true, message: '请输入文件名' }]"
              :required="true">
              <el-input v-model="downloadErrorView.form.fileName">
                <template slot="append">.xlsx</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer">
        <el-button @click="downloadErrorView.show = false">取 消</el-button>
        <el-button type="primary" @click="toDownloadErrorView">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 下载模板 -->
    <el-dialog title="下载模板" :visible.sync="downloadView.show" width="30%" top="15vh" :append-to-body="true">
      <el-row>
        <el-form :inline="true" ref="downloadView" :model="downloadView.form" label-suffix=":">
          <el-col :span="24">
            <el-form-item label="文件名称" prop="fileName" :rules="[{ required: true, message: '请输入文件名' }]"
              :required="true">
              <el-input v-model="downloadView.form.fileName">
                <template slot="append">.xlsx</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer">
        <el-button @click="downloadView.show = false">取 消</el-button>
        <el-button type="primary" @click="toDownloadView">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 导出数据 -->
    <el-dialog title="导出数据" :visible.sync="downloadData.show" width="30%" top="15vh" :append-to-body="true">
      <el-row>
        <el-form :inline="true" ref="downloadView" :model="downloadData.form" label-suffix=":">
          <el-col :span="24">
            <el-form-item label="文件名称" prop="fileName" :rules="[{ required: true, message: '请输入文件名' }]"
              :required="true">
              <el-input v-model="downloadData.form.fileName">
                <template slot="append">.xlsx</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer">
        <el-button @click="downloadData.show = false">取 消</el-button>
        <el-button type="primary" @click="todownloadData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rola: false,
      activeName: "first",
      data: [],
      loading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1,
      },
      search: {},
      TabOption: {
        // title: "考勤异常数据管理",
        // menuType: "text",
        selection: true,
        page: true,
        align: "center",
        dateDefault: false,
        menuAlign: "center",
        searchIndex: 3,
        menuWidth: 80,
        searchLabelWidth: 80,
        searchMenuSpan: 5,
        tip: false,
        menu: true,
        refreshBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: true,
        addBtn: false,
        border: true,
        column: [
          {
            label: "id",
            prop: "id",
            addDisplay: false,
            viewDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: "工号",
            prop: "gh",
            search: true,
            searchLabelWidth: 50,
            minWidth: 60,
            searchSpan: 4,
            rules: [
              {
                required: true,
                message: "请输入工号",
                trigger: "blur",
              },
            ],
          },

          {
            label: "姓名",
            prop: "xm",
            search: true,
            searchSpan: 4,
            searchLabelWidth: 50,
            minWidth: 40,
            rules: [
              {
                required: true,
                message: "请输入姓名",
                trigger: "blur",
              },
            ],
          },
          {
            label: "异常类型",
            prop: "sxb",
            // search: true,
            rules: [
              {
                required: true,
                message: "请输入异常类型",
                trigger: "blur",
              },
            ],
          },

          {
            label: "日期",
            prop: "ycrq",
            minWidth: 60,
            // search: true,
            rules: [
              {
                required: true,
                message: "请输入日期",
                trigger: "blur",
              },
            ],
          },

          {
            label: "处理状态",
            prop: "clzt",
            search: true,
            minWidth: 60,
            searchSpan: 5,
            type: "select",
            dicData: [
              {
                value: 1,
                label: "未处理",
              },
              {
                value: 4,
                label: "审核中",
              },
              {
                value: 2,
                label: "已通过",
              },
              {
                value: 3,
                label: "未通过",
              },
            ],
            slot: true,
            rules: [
              {
                required: false,
                message: "请输入处理状态",
                trigger: "blur",
              },
            ],
          },

          {
            label: "原因",
            prop: "yy",
            // search: true,
            overHidden: true,
            rules: [
              {
                required: false,
                message: "请输入原因",
                trigger: "blur",
              },
            ],
          },
          {
            label: "主管意见",
            prop: "zgyj",
            // search: true,
            minWidth: 60,
            rules: [
              {
                required: false,
                message: "请输入原因",
                trigger: "blur",
              },
            ],
          },
          {
            label: "日期范围",
            prop: "rqfw",
            hide: true,
            search: true,
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            searchRange: true,
            searchClearble: true,
            searchSpan: 6,
            viewDisplay: false,
          },

          // {
          //   label: "联系方式",
          //   prop: "sjhm",
          //   hide: true,
          //   rules: [
          //     {
          //       required: true,
          //       message: "请输入联系方式",
          //       trigger: "blur",
          //     },
          //   ],
          // },
        ],
      },

      uploadView: {
        show: false,
        form: {
          excelTemplateType: "",
          fileName: "考勤异常数据",
        },
      },

      uploadViewData: {
        label: "上传文件",
      },

      downloadView: {
        show: false,
        form: {
          excelTemplateType: "",
          fileName: "考勤异常数据",
        },
      },
      downloadErrorView: {
        show: false,
        form: {
          excelTemplateType: "",
          fileName: "错误数据",
        },
      },

      downloadData: {
        show: false,
        form: {
          excelTemplateType: "",
          fileName: "导出考勤异常数据",
        },
      },
      tbSrc: "",
      file: "",
      src: "",
      FDFS_IMG: "",
      idArr: "",
    };
  },
  mounted() {
    this.FDFS_IMG = window.config.FDFS_WEB_SERVER_URL;
    // 判断角色
    let roleCodeList = this.$store.getters.userInfo.subject.roleList.map(
      (item) => item.roleCode
    );
    if (roleCodeList.indexOf("kqycgl") > -1) {
      this.rola = true;
      this.TabOption.addBtn = true;
      this.TabOption.editBtn = true;
      this.TabOption.delBtn = true;
    }
  },
  methods: {
    // 分页查询
    load(done) {
      this.$http
        .post(
          "/unusualAttendance/query",
          {
            entity: {
              ...this.search,
            },
            orderItemList: [
              {
                asc: false,
                column: "id",
              },
            ],
          },
          {
            params: {
              pageNum: this.page.currentPage,
              pageSize: this.page.pageSize,
            },
          }
        )
        .then((res) => {
          this.data = res.data.records || [];
          this.page.total = res.data.total || res.data.records.length || 0;
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message);
        })
        .finally(() => {
          typeof done === "function" && done();
        });
    },
    onLoad(page) {
      this.page.currentPage = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.load();
    },
    searchChange(params, done) {
      this.search = params;
      this.page.currentPage = 1;
      this.load(done);
    },
    searchReset() {
      this.search = {};
      this.page.currentPage = 1;
      this.load();
    },
    refreshChange() {
      this.load();
    },

    rowAdd: function () {
      this.$refs.crud.rowAdd();
    },

    rowSave: function (row, done, loading) {
      delete row["id"];
      this.$http
        .post("/unusualAttendance/save", row)
        .then((response) => {
          this.$message.success("操作成功");
          this.load();
          done();
        })
        .catch((error) => {
          done();
          if (error.code === 13) {
            this.$message.error(error.data);
          } else {
            this.$message.error(error.msg);
          }
        });
    },
    rowUpdate: function (row, index, done, loadings) {
      this.$http
        .post("/unusualAttendance/update", row)
        .then((response) => {
          this.$message.success("操作成功");
          this.load();
          done();
        })
        .catch((error) => {
          done();
          if (error.code === 13) {
            this.$message.error(error.data);
          } else {
            this.$message.error(error.msg);
          }
        });
    },
    rowDel(row, index) {
      this.$confirm("是否确认删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .delete("/unusualAttendance/delete", {
              params: {
                id: row.id.split(","),
              },
            })
            .then((response) => {
              this.$message.success("操作成功");

              this.load();
            })
            .catch((error) => {
              this.$message.error(error.msg);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    showSystemDate: function () {
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      };
      if (date.month < 10) {
        date.month = "0" + date.month;
      }
      if (date.date < 10) {
        date.date = "0" + date.date;
      }
      let systemDate = date.year + "-" + date.month + "-" + date.date;
      return systemDate;
    },
    downloadViewFunc: function () {
      this.downloadView.show = true;
      if (this.$refs.downloadView) {
        this.$refs.downloadView.resetFields();
      }
      this.downloadView.form = {
        excelTemplateType: "",
        fileName: "考勤异常数据导入模板",
      };
    },
    toDownloadView: function () {
      this.$refs.downloadView.validate((valid) => {
        if (valid) {
          this.$downloadFile
            .get("/unusualAttendance/templateExport", {
              params: {
                fileName: this.downloadView.form.fileName + ".xlsx",
                doDownload: true,
              },
            })
            .then((response) => {
              // 返回的内容
              this.$message.success(response.msg);
              this.downloadView.show = false;
            })
            .catch((error) => {
              this.$message.error(error);
            });
        }
      });
    },

    toDownloadErrorView: function () {
      this.$refs.downloadView.validate((valid) => {
        if (valid) {
          this.$downloadFile
            .get("/unusualAttendance/errorDataExport", {
              params: {
                fileName: this.downloadErrorView.form.fileName + ".xlsx",
                doDownload: true,
              },
            })
            .then((response) => {
              // 返回的内容
              this.$message.success(response.msg);
              this.downloadErrorView.show = false;
            })
            .catch((error) => {
              this.$message.error(error);
            });
        }
      });
    },
    downloadDataFun: function () {
      this.downloadData.show = true;
      if (this.$refs.downloadData) {
        this.$refs.downloadData.resetFields();
      }
      let ststemDate = this.showSystemDate();
      this.downloadData.form = {
        excelTemplateType: "",
        fileName: "考勤异常数据_" + ststemDate,
      };
    },
    todownloadData: function () {
      let params = {};

      params.fileName = this.downloadData.form.fileName + ".xlsx";
      params.doDownload = true;

      this.$refs.downloadView.validate((valid) => {
        if (valid) {
          this.$downloadFile
            .post(
              "/unusualAttendance/dataExport", //导出
              {
                entity: {
                  ...this.search,
                },
                orderItemList: [
                  {
                    asc: false,
                    column: "id",
                  },
                ],
              },
              { params }
            )
            .then((response) => {
              // 返回的内容
              this.$message.success(response.msg);
              this.downloadData.show = false;
            })
            .catch((error) => {
              this.$message.error(error);
            });
        }
      });
    },
    uploadFile: function () {
      this.uploadView.show = true;
      this.uploadView.form = {
        excelTemplateType: "",
        fileName: "导出用户管理数据",
      };
    },
    toUploadFile: function () {
      let formData = new window.FormData(); // vue 中使用 window.FormData(),否则会报 'FormData isn't definded'
      formData.append("file", this.file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      this.$http
        .post("/unusualAttendance/import", formData, config)
        .then((res) => {
          this.uploadView.show = false;
          this.$message.success("文件上传成功!");
          this.load();
        })
        .catch((error) => {
          // debugger;
          if (error.code == "444") {
            this.$confirm("考勤异常数据 - 导入数据失败!" + error.msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.uploadView.show = false;
                this.downloadErrorView.show = true;
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消下载",
                });
              });
            this.$message.error("考勤异常数据 - 导入数据失败!" + error.msg);
          }
        });
    },

    deleteRows(deleteArray = this.SELECT_LIST) {
      this.$http
        .get("/unusualAttendance/reminders", {
          params: {
            idList: this.idArr,
          },
        })
        .then((response) => {
          this.delLoading = false;
          this.$message.success("催办成功！");
          this.loadData();
        });
    },

    uploading(event) {
      this.file = event.target.files[0]; // 获取文件

      var windowURL = window.URL || window.webkitURL;

      this.file = event.target.files[0];

      // 创建图片文件的url

      this.src = windowURL.createObjectURL(event.target.files[0]);

      this.uploadViewData.label = this.file.name;
    },
    closeUploadDialog: function () {
      this.uploadViewData.label = "上传文件";
    },
    selectionChange(list) {
      let idArr = list.map((item) => {
        return item.id;
      });
      console.log(idArr);
      this.idArr = idArr;
    },
  },
};
</script>

<style lang="scss" scoped>
.file {
  z-index: 999;
  opacity: 0;
  position: absolute;
  left: 2px;
  width: 140px;
  cursor: pointer;
  height: 44px;
}
.file_btn {
  position: absolute;
  left: 2px;
  width: auto;
  z-index: 0;
}
.table-div {
  padding: 20px 20px 100px;
  background-color: #fff;
  max-width: 1680px;
  width: calc(100% - 30px);
  margin: 0 0 0 10px;
  :deep(.avue-form__menu--center) {
    text-align: left;
  }
  :deep(.avue-crud__title) {
    height: 30px;
  }
  :deep(.el-tabs--border-card) {
    box-shadow: none;
  }

  .text-center {
    text-align: center;
  }

  .yy_notice {
    background-image: url("/base/images/scwlIndex/banner.png");
    width: 600px;
    margin: auto;
    border: 1px solid #ececec;
    text-align: center;
    height: 150px;
    line-height: 150px;
    color: white;
    margin-bottom: 30px;
  }
}
</style>
